import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/Capture5.JPG";
import emotion from "../../Assets/Projects/Capture8.jpg";
import emotions from "../../Assets/Projects/Capture9.JPG";
import editor from "../../Assets/Projects/Capture3.JPG";
import chatify from "../../Assets/Projects/Capture1.JPG";
import suicide from "../../Assets/Projects/Capture7.JPG";
import bitsOfCode from "../../Assets/Projects/Capture2.JPG";
import empl from "../../Assets/Projects/Capture11.jpg";
import IoT from "../../Assets/Projects/Capture10.JPG";
import dnd from "../../Assets/Projects/Capture12.png";
import chat from "../../Assets/Projects/Capture13.JPG"
import scheduling from "../../Assets/Projects/Capture14.png"
import teeprint from "../../Assets/Projects/Screenshot_16.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={teeprint}
              isBlog={false}
              title="Teeprint London ( A professional custom printing service in London)"
              tech="Nuxt.js Pinia Bootstrap Paypal Laravel CSS swiper"
              ghLink="https://github.com/NeazMorshed180031/teeprint-london"
              demoLink="https://teeprintlondon.co.uk/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="E-Commerce Website By MERN Stack"
              tech="React.js Redux Stripe Node.js Express.js MongoDB Bootstrap"
              ghLink="https://github.com/NeazMorshed180031/MERN_E_Commerce"
              demoLink="https://laptopify.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Burger Builder and Order by React.js"
              ghLink="https://github.com/NeazMorshed180031/Burger-Builder"
              demoLink="https://burgerbuilderhub.netlify.app/"
              tech="React.js CSS Firebase React-Router CSS"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chat}
              isBlog={false}
              title="Chat App by React"
              ghLink="https://github.com/NeazMorshed180031/chatapp"
              demoLink="https://original-p7iw.onrender.com/"
              tech="React.js Socket.io Express.js Node.js Tailwind daisyui"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Movie Hub By React"
              tech="React.js SCSS React-Router Redux Redux-Toolkit"
              ghLink="https://github.com/NeazMorshed180031/movieapp"
              demoLink="https://magicalmoviehouse.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dnd}
              isBlog={false}
              title="Drag and Drop by React (dnd)"
              tech="React.js Tailwind React-Router dnd"
              ghLink="https://github.com/NeazMorshed180031/Gallery_App"
              demoLink="https://ollyogalllery.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Frontend Of Admin Dashboard"
              ghLink="https://github.com/NeazMorshed180031/admin_dashboard"
              demoLink="https://admindashboardbyreact.netlify.app/"
              tech="React.js Bootstrap SCSS React-Chart.js"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={empl}
              isBlog={false}
              title="Employee Management System by Spring Boot"
              ghLink="https://github.com/NeazMorshed180031/emplpro.git"
              demoLink="https://employeemanagementsa.netlify.app/"
              tech="React.js Java Spring-Boot MySql"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Mars mission Calculator By Java"
              ghLink="https://github.com/NeazMorshed180031/Scientific-Calculator"
              tech="Java JavaFX FSM JTable Geometry"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={scheduling}
              isBlog={false}
              title="Scheduling Algorithms Visualizer"
              ghLink="https://github.com/NeazMorshed180031/Scheduling-Algorithms-Visualizer"
             tech="Java JavaFX Multi-threading Visualization Scheduling-Algorithms"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Personal Information Management Tool or Java Dictionary"
              ghLink="https://github.com/NeazMorshed180031/Java-Dictionary"
              tech="Java JavaFX Search-Text File-Load"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotions}
              isBlog={false}
              title="Statistical Graph In Python"
              ghLink="https://github.com/NeazMorshed180031/Statistical-Graph-in-Python"
              tech="Python Matplotlib xlrd tkinter Scipy Numpy"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={IoT}
              isBlog={false}
              title="Smart Home Irrigation System"
              ghLink="https://github.com/NeazMorshed180031/Smart-Home-Irrigation-System"
              tech="Circuit-Design C Breadboard Tinkercad"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
